/**
 * Constants for element classification and attribute mapping
 */

/**
 * Maps HTML attribute names to React prop names
 */
export const ATTRIBUTE_MAP: Record<string, string> = {
  class: 'className',
  for: 'htmlFor',
  tabindex: 'tabIndex',
  readonly: 'readOnly',
  maxlength: 'maxLength',
  contenteditable: 'contentEditable',
  colspan: 'colSpan',
  rowspan: 'rowSpan',
};

export const URI_ATTRIBUTES: ReadonlySet<Lowercase<string>> = new Set([
  'href',
  'src',
  'xlink:href',
  'poster',
  'action',
  'formaction',
  'ping',
  'cite',
  'data',
  'srcset',
]);

/**
 * Void elements that don't have children
 */
export const VOID_ELEMENTS: ReadonlySet<string> = new Set([
  'img',
  'br',
  'hr',
  'area',
  'base',
  'basefont',
  'col',
  'embed',
  'input',
  'link',
  'meta',
  'param',
  'source',
  'track',
  'wbr',
]);

/**
 * Table elements that need whitespace filtering
 */
export const TABLE_ELEMENTS: ReadonlySet<string> = new Set([
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'th',
  'td',
  'colgroup',
]);

/**
 * Heading elements
 */
export const HEADING_ELEMENTS: ReadonlySet<string> = new Set([
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
]);
